export default "__VITE_ASSET__RhZbIb2z__"